import React from "react";
import { Navigate } from "react-router-dom";
import { isTokenValid } from "../Utils/authHelper";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token || !isTokenValid(token)) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
